// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import TournamentStructure from '../tournamentStructure';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { colors, btn, card, form, breadcrumb, search as searchStyles } from '../../../../style/common/partnerStyle';

function Toast({ message, type, onClose }) {
  if (!message) return null;
  const bg     = type === 'error' ? colors.dangerLt  : colors.successLt;
  const color  = type === 'error' ? colors.danger     : colors.success;
  const border = type === 'error' ? '#fca5a5'          : '#6ee7b7';
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '12px 16px', borderRadius: 8, marginBottom: 16,
      background: bg, border: `1px solid ${border}`, fontSize: 13,
    }}>
      <span style={{ color, fontWeight: 600 }}>{message}</span>
      <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color, fontSize: 16, lineHeight: 1, padding: '0 0 0 12px' }}>✕</button>
    </div>
  );
}

class TournamentCompetition extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      venues: [],
      city: [],
      additional_fields: [],
      sub_categories: {},
      tournament_id: props.match.params.id,
      tournament_name: props.match.params.name,
      games: [],
      mobile_no: '',
      categories: [],
      age_groups: [],
      genders: [],
      coordinaters: [],
      buddy_search_list: [],
      showStructure: false,
      competitions_id: '',
      search: false,
      search_loading: false,
      toast: null,
      competition_details: {
        tournament_id: props.match.params.id,
        game: 1,
        category: '',
        gender: '',
        age_group: '',
        prize_and_perks: '',
        description: '',
        registration_amount: 0,
        coordinaters: [],
        venue: [],
        start_date: moment(),
        end_date: moment(),
        registration_closed: moment().set({ hour: 23, minute: 59, second: 0, millisecond: 0 }),
        is_team_competition: true,
      },
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getSearchList = this.getSearchList.bind(this);
    this.setSearch = this.setSearch.bind(this);
    this.handleStartDate = this.handleStartDate.bind(this);
    this.handleEndDate = this.handleEndDate.bind(this);
    this.handleRegDateTime = this.handleRegDateTime.bind(this);
  }

  componentDidMount() {
    this.getTournamentDetails();
  }

  showToast(message, type = 'error') {
    this.setState({ toast: { message, type } });
  }

  getTournamentDetails() {
    const url = `${getLocationOrigin()}/eagleeye/get_inputs_for_add_tournament_competition/?tournament_id=${this.state.tournament_id}`;
    const options = {...defaultOptions};
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => {
        this.setState({
          venues: data.venues,
          city: data.cities,
          sub_categories: data.sub_categories,
          games: data.games,
          categories: data.categories,
          age_groups: data.age_groups,
          genders: data.genders,
          additional_fields: data.registration_additional_fields,
        });
      })
      .catch(error => error);
  }

  handleStartDate(date) {
    var new_selected_one = Object.assign({}, this.state.competition_details);
    new_selected_one['start_date'] = date;
    this.setState({ competition_details: new_selected_one });
  }

  handleEndDate(date) {
    var new_selected_one = Object.assign({}, this.state.competition_details);
    new_selected_one['end_date'] = date;
    this.setState({ competition_details: new_selected_one });
  }

  handleRegDateTime(event) {
    const new_selected_one = Object.assign({}, this.state.competition_details);
    const [date, time] = event.target.value.split('T');
    new_selected_one['registration_closed'] = moment(`${date} ${time}`);
    this.setState({ competition_details: new_selected_one });
  }

  postCreateCompetition() {
    var data = this.state.competition_details;
    console.log(data);
    if(!data.city) { data.city = null; }
    if(data.age_group == '') { data.age_group = this.state.age_groups[0].id; }
    if(data.category == '') { data.category = this.state.categories[0][0]; }
    if(data.gender == '') { data.gender = this.state.genders[0][0]; }
    if(data.game == '') { data.game = this.state.games[0].pk; }
    if(data.is_team_competition) {
      data.category = this.state.categories[0][0];
      this.state.genders[0][0];
    }
    if(this.state.additional_fields.includes('cities') && !data.city) {
      this.showToast('Please fill the City field');
      return;
    }
    const url = `${getLocationOrigin()}/tournament/add_tournament_competition/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = { 'content-type': 'application/json' };
    options['body'] = JSON.stringify({
      'tournament_id': data.tournament_id,
      'registration_amount': data.registration_amount,
      'prize_and_perks': data.prize_and_perks,
      'category': data.category,
      'game': data.game,
      'gender': data.gender,
      'age_group': data.age_group,
      'coordinaters': data.coordinaters,
      'venue': data.venue,
      'city': data.city,
      'start_date': data.start_date,
      'end_date': data.end_date,
      'registration_closed': data.registration_closed,
      'description': data.description,
      'is_team_competition': data.is_team_competition,
    });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then((response) => {
        this.showToast(response.message, 'success');
        if(response.success) {
          setTimeout(() => { this.props.history.goBack(); }, 800);
        }
      })
      .catch(error => {
        console.log(error);
        this.showToast(error && error.message ? error.message : 'Failed to create competition');
      });
  }

  getSearchList() {
    const term = this.state.mobile_no;
    if(!term || String(term).trim().length < 3) {
      this.showToast('Enter at least 3 characters to search');
      return;
    }
    this.setState({ search_loading: true, toast: null });
    const url = `${getLocationOrigin()}/eagleeye/search_buddy/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = { 'content-type': 'application/json' };
    options['body'] = JSON.stringify({ 'search': term });
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => {
        if(data.Message) {
          this.setState({ buddy_search_list: [], search: false, search_loading: false });
          this.showToast(data.Message);
          return;
        }
        this.setState({
          buddy_search_list: Array.isArray(data.results) ? data.results : [],
          search: true,
          search_loading: false,
        });
      })
      .catch(error => {
        console.log(error);
        this.setState({ buddy_search_list: [], search: false, search_loading: false });
        this.showToast(error && error.message ? error.message : 'Search failed. Please try again.');
      });
  }

  setSearch(name, buddy_id, mobile_no) {
    var new_selected_one = Object.assign({}, this.state.competition_details);
    new_selected_one.coordinaters.push(buddy_id);
    this.setState({ competition_details: new_selected_one, search: false, buddy_search_list: [] });
    this.state.coordinaters.push([buddy_id, name]);
  }

  setCordinater(name, buddy_id, mobile_no) {
    var new_selected_one = Object.assign({}, this.state.prev_competition_details);
    new_selected_one.coordinator.push([buddy_id, name]);
    this.setState({ prev_competition_details: new_selected_one, search: false });
  }

  removeCoordinater(name, coordinator_id) {
    var new_selected_one = Object.assign({}, this.state.competition_details);
    new_selected_one.coordinaters.pop(coordinator_id);
    this.setState({ competition_details: new_selected_one, search: false });
    this.state.coordinaters.pop([coordinator_id, name]);
  }

  handleChangeForNew(event) {
    console.log(event.target.name, event.target.value);
    var name = event.target.name;
    if(name == 'mobile_no') {
      this.setState({ mobile_no: event.target.value });
    } else if(name == 'is_team_competition') {
      var new_selected_one = Object.assign({}, this.state.competition_details);
      new_selected_one[name] = !this.state.competition_details.is_team_competition;
      this.setState({ competition_details: new_selected_one });
    } else if(name == 'game') {
      var new_selected_one = Object.assign({}, this.state.competition_details);
      new_selected_one[name] = event.target.value;
      if(event.target.value != 1 && event.target.value != 4 && event.target.value != 8 && event.target.value != 7) {
        new_selected_one['is_team_competition'] = false;
      } else {
        new_selected_one['is_team_competition'] = true;
      }
      this.setState({ competition_details: new_selected_one });
    } else {
      var new_selected_one = Object.assign({}, this.state.competition_details);
      new_selected_one[name] = event.target.value;
      this.setState({ competition_details: new_selected_one });
    }
  }

  handleMultiselect(event) {
    const name = event.target.name;
    var options = event.target.options;
    var new_selected_one = Object.assign({}, this.state.competition_details);
    var ids = [];
    if(event) {
      for (var i = 0, l = options.length; i < l; i++) {
        if (options[i].selected) { ids.push(options[i].value); }
      }
    }
    else {}
    new_selected_one[name] = ids;
    this.setState({ competition_details: new_selected_one });
  }

  deleteCompetition() {
    const url = `${getLocationOrigin()}/tournament/delete_tournament_competition/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = { 'content-type': 'application/json' };
    options['body'] = JSON.stringify({ 'competition_id': this.state.prev_competition_details.id });
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => { alert(data.message); window.location.reload(); })
      .catch(error => { console.log(error); alert(error.message); });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.postCreateCompetition();
  }

  handleCancel() { this.props.history.goBack(); }

  render() {
    console.log(this.state.competition_details.is_team_competition);
    console.log("in render");

    const { competition_details, coordinaters, search, buddy_search_list, search_loading, toast } = this.state;
    const isTeamSport = competition_details.game == 1 || competition_details.game == 4 || competition_details.game == 8 || competition_details.game == 7;

    return (
      <div style={{ fontFamily: "'DM Sans', 'Segoe UI', sans-serif", background: colors.bg, minHeight: '100vh', boxSizing: 'border-box' }}>

        {/* Breadcrumb */}
        <div style={breadcrumb.wrap}>
          <a href={'/#/partnerTournament'} style={breadcrumb.link}>Events</a>
          <span style={breadcrumb.separator}>›</span>
          <a href={`/#/crud/viewTournament/${this.state.tournament_id}`} style={breadcrumb.link}>{this.state.tournament_name}</a>
          <span style={breadcrumb.separator}>›</span>
          <span style={breadcrumb.current}>Add Competition</span>
        </div>

        <div style={{ padding: '0 20px 40px' }}>
          <div style={{ maxWidth: 680, margin: '0 auto' }}>
            <div style={{ background: colors.surface, borderRadius: 12, boxShadow: '0 1px 4px rgba(0,0,0,0.08), 0 4px 16px rgba(0,0,0,0.06)', overflow: 'hidden' }}>

              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 24px', borderBottom: `1px solid ${colors.border}` }}>
                <h2 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: colors.text }}>Add Competition</h2>
              </div>

              <div style={{ padding: '20px 24px' }}>
                <Toast message={toast && toast.message} type={toast && toast.type} onClose={() => this.setState({ toast: null })} />

                <form className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

                  <div style={form.row}>
                    <div style={form.labelWide}>Game</div>
                    <select name="game" style={form.select} value={competition_details.game} onChange={(e) => { this.handleChangeForNew(e); }}>
                      {this.state.games.map((x, index) => (
                        <option key={x.pk} value={x.pk}>{x.name}</option>
                      ))}
                    </select>
                  </div>

                  {/* Team competition toggle — only for non-team sports */}
                  {!isTeamSport && (
                    <div style={form.row}>
                      <div style={form.labelWide}>Is Team Competition?</div>
                      <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 13, color: colors.text }}>
                        <input
                          name="is_team_competition"
                          type="checkbox"
                          onChange={(e) => { this.handleChangeForNew(e); }}
                          checked={competition_details.is_team_competition}
                          style={{ width: 16, height: 16, cursor: 'pointer', accentColor: colors.brand }}
                        />
                        <span>Yes, this is a team competition</span>
                      </label>
                    </div>
                  )}

                  {/* Category + Gender — only for individual competitions */}
                  {!isTeamSport && !competition_details.is_team_competition && (
                    <div>
                      <div style={form.row}>
                        <div style={form.labelWide}>Category</div>
                        <select name="category" style={form.select} value={this.state.value} onChange={(e) => { this.handleChangeForNew(e); }}>
                          {this.state.categories.map((format, index) => (
                            <option key={index} value={format[0]}>{format[1]}</option>
                          ))}
                        </select>
                      </div>
                      <div style={form.row}>
                        <div style={form.labelWide}>Gender</div>
                        <select name="gender" style={form.select} value={this.state.value} onChange={(e) => { this.handleChangeForNew(e); }}>
                          {this.state.genders.map((format, index) => (
                            <option key={index} value={format[0]}>{format[1]}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  )}

                  <div style={form.row}>
                    <div style={form.labelWide}>Age Group</div>
                    <select name="age_group" id="age_group" style={form.select} value={this.state.value} onChange={(e) => { this.handleChangeForNew(e); }}>
                      {this.state.age_groups.map((age_group, index) => (
                        <option key={index} value={age_group.id}>{age_group.name}</option>
                      ))}
                    </select>
                  </div>

                  <div style={form.row}>
                    <div style={form.labelWide}>Start Date</div>
                    <DatePicker dateFormat="DD/MM/YYYY" selected={competition_details.start_date} onChange={this.handleStartDate} />
                  </div>

                  <div style={form.row}>
                    <div style={form.labelWide}>End Date</div>
                    <DatePicker dateFormat="DD/MM/yyyy" selected={competition_details.end_date} onChange={this.handleEndDate} />
                  </div>

                  <div style={form.row}>
                    <div style={form.labelWide}>Registration End Date & Time</div>
                    <input
                      type="datetime-local"
                      name="registration_closed"
                      style={form.input}
                      onChange={(e) => this.handleRegDateTime(e)}
                      value={moment(competition_details.registration_closed).format('YYYY-MM-DDTHH:mm')}
                    />
                  </div>

                  <div style={form.row}>
                    <div style={form.labelWide}>Venues</div>
                    <select name="venue" id="venue" style={{ ...form.select, minHeight: 80 }} value={this.state.value} multiple={true} onChange={(e) => { this.handleMultiselect(e); }}>
                      {Object.keys(this.state.venues).map((key, index) => (
                        <option key={index} value={this.state.venues[key].id}>{this.state.venues[key].name}</option>
                      ))}
                    </select>
                  </div>
                  <div style={{ marginBottom: 14, paddingLeft: 212 }}>
                    <small style={{ color: colors.muted, fontSize: 11 }}>* use &lt;Ctrl&gt; for multiple selection</small>
                  </div>

                  {this.state.additional_fields.includes('cities') && (
                    <div style={form.row}>
                      <div style={form.labelWide}>City</div>
                      <select name="city" id="city" style={form.select} value={this.state.value} onChange={(e) => { this.handleChangeForNew(e); }}>
                        <option value="">..........</option>
                        {this.state.city.map((city, index) => (
                          <option key={index} value={city.id}>{city.name}</option>
                        ))}
                      </select>
                    </div>
                  )}

                  {/* Coordinator search */}
                  <div style={form.row}>
                    <div style={form.labelWide}>Search Coordinator</div>
                    <div style={form.searchWrap}>
                      <input
                        type="text"
                        name="mobile_no"
                        placeholder="Name or mobile (min 3 chars)…"
                        style={form.searchInput}
                        value={this.state.mobile_no}
                        onChange={(e) => { this.handleChangeForNew(e); }}
                        onKeyDown={e => e.key === 'Enter' && (e.preventDefault(), this.getSearchList())}
                      />
                      <button
                        type="button"
                        style={{ ...form.searchBtn, opacity: search_loading ? 0.6 : 1 }}
                        onClick={this.getSearchList}
                        disabled={search_loading}
                      >
                        {search_loading ? '…' : '🔍'}
                      </button>
                    </div>
                  </div>

                  {search && (
                    <div style={{ marginBottom: 14, paddingLeft: 212 }}>
                      {buddy_search_list.length ? (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                          {buddy_search_list.map(x => (
                            <button
                              key={x.mobile_no + x.name}
                              type="button"
                              style={{ ...btn.outline, fontSize: 12, padding: '6px 12px' }}
                              onClick={() => this.setSearch(x.name, x.id, x.mobile_no)}
                            >
                              {x.name}: {x.mobile_no}
                            </button>
                          ))}
                        </div>
                      ) : (
                        <div style={searchStyles.notFound}>
                          <span style={searchStyles.notFoundText}>No coordinator found</span>
                        </div>
                      )}
                    </div>
                  )}

                  {/* Selected coordinators */}
                  {coordinaters.length > 0 && (
                    <div style={form.row}>
                      <div style={form.labelWide}>Selected Coordinators</div>
                      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 6 }}>
                        {coordinaters.map((coordinator, index) => (
                          <div key={index} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <span style={{ fontSize: 13, color: colors.text }}>{coordinator[1]}</span>
                            <button
                              type="button"
                              style={{ ...btn.dangerLt, padding: '3px 8px', fontSize: 11 }}
                              onClick={() => { this.removeCoordinater(coordinator[0], coordinator[1]); }}
                            >✕</button>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/*<div style={form.row}>
                    <div style={form.labelWide}>Prize and Perks</div>
                    <textarea rows="4" style={form.textarea} name="prize_and_perks" placeholder="Enter Prize and Perks" onChange={(e) => { this.handleChangeForNew(e); }} />
                  </div>*/}
                  {/*<div style={form.row}>
                    <div style={form.labelWide}>Description</div>
                    <textarea rows="4" style={form.textarea} name="description" placeholder="Enter Competition Description" onChange={(e) => { this.handleChangeForNew(e); }} />
                  </div>*/}

                  <div style={form.row}>
                    <div style={form.labelWide}>Registration Amount</div>
                    <input type="number" name="registration_amount" style={form.input} className="required" value={this.state.value} onChange={(e) => { this.handleChangeForNew(e); }} />
                  </div>

                  <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', paddingTop: 16, borderTop: `1px solid ${colors.border}`, marginTop: 8 }}>
                    <button type="button" style={btn.cancel} onClick={() => { this.handleCancel(); }}>Cancel</button>
                    <button type="button" style={btn.primary} onClick={() => { this.postCreateCompetition(); }}>Create</button>
                  </div>

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TournamentCompetition;


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addCompetition/index.js